import { render, staticRenderFns } from "./Process.vue?vue&type=template&id=33bc31d2&scoped=true&"
import script from "./Process.vue?vue&type=script&lang=ts&"
export * from "./Process.vue?vue&type=script&lang=ts&"
import style0 from "./Process.vue?vue&type=style&index=0&id=33bc31d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33bc31d2",
  null
  
)

export default component.exports